import { fetchLists } from './bao-swym.js'

class WishlistCount extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setCountFromStorage()
  }

  setupListeners () {
    super.setupListeners()

    document.addEventListener('swym-item-added', () => {
      const count = parseInt(this.dataset.count)

      this.dataset.count = count + 1
      this.textContent = count + 1
    })

    document.addEventListener('swym-item-removed', () => {
      const count = this.dataset.count

      this.dataset.count = count - 1
      this.textContent = count - 1
    })
  }

  setCountFromStorage () {
    fetchLists().then(lists => {
      let count = 0

      lists.forEach(list => {
        count += list.listcontents.length
      })

      this.dataset.count = count
      this.textContent = count
    })
  }
}

if (!customElements.get('wishlist-count')) {
  customElements.define('wishlist-count', WishlistCount)
}
